import {useAppSelector} from "../../../redux/hooks";
import {useCallback} from 'react';
import {
  getIsMySongsPageFilterDifficultyCategoryPartiallySelected,
  getIsMySongsPageFilterDifficultyCategorySelected
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterDifficultyCategoryLogic {
  title?: string;
  isSelected: boolean;
  handleToggleOnClick: () => void;
  isPartialSelected: boolean;
}

export const useFilterDifficultyCategoryLogic = (id: number): IFilterDifficultyCategoryLogic => {
  const title = useAppSelector(() => mySongsFiltersStore.getDifficultyCategoryFromId(id)?.name)
  const isSelected = useAppSelector((store) => getIsMySongsPageFilterDifficultyCategorySelected(store, id));
  const isPartialSelected = useAppSelector((store) => getIsMySongsPageFilterDifficultyCategoryPartiallySelected(store, id));
  const handleToggleOnClick = useCallback(() => {
    mySongsPageStore.toggleFilterDifficultyCategoryById(id);
  }, [id])
  return {
    title,
    isSelected,
    isPartialSelected,
    handleToggleOnClick,
  };
}
